import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d6a1707c")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_eHeader = _resolveComponent("eHeader")
  const _component_el_header = _resolveComponent("el-header")
  const _component_router_view = _resolveComponent("router-view")
  const _component_el_main = _resolveComponent("el-main")
  const _component_EFooter = _resolveComponent("EFooter")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_backtop = _resolveComponent("el-backtop")
  const _component_el_container = _resolveComponent("el-container")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")

  return (_openBlock(), _createBlock(_component_el_scrollbar, { ref: "scrollbar" }, {
    default: _withId(() => [
      _createVNode(_component_el_container, { class: "content-wrapper" }, {
        default: _withId(() => [
          _createVNode(_component_el_header, {
            height: "",
            class: "app-header"
          }, {
            default: _withId(() => [
              _createVNode(_component_eHeader)
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, { class: "app-main" }, {
            default: _withId(() => [
              _createVNode(_component_router_view, null, {
                default: _withId(({ Component }) => [
                  (_openBlock(), _createBlock(_KeepAlive, { include: _ctx.keepAliveComp }, [
                    (_ctx.isRouterAlive)
                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                          key: _ctx.route.fullPath
                        }))
                      : _createCommentVNode("", true)
                  ], 1032, ["include"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_footer, null, {
            default: _withId(() => [
              _createVNode(_component_EFooter)
            ]),
            _: 1
          }),
          _createVNode(_component_el_backtop, {
            target: ".el-scrollbar__wrap",
            bottom: 75
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
})